module.exports = __webpack_public_path__ + "img/ics_o_search.d5a962cf.svg";